import { render, staticRenderFns } from "./checkout-bank-slip.vue?vue&type=template&id=5e8d25e7&scoped=true"
import script from "./checkout-bank-slip.vue?vue&type=script&lang=js"
export * from "./checkout-bank-slip.vue?vue&type=script&lang=js"
import style0 from "./checkout-bank-slip.scss?vue&type=style&index=0&id=5e8d25e7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d25e7",
  null
  
)

export default component.exports